import {
  Category1,
  Category2,
  Category3,
  Category4,
  Category5,
  Category6,
} from "../../_components/Imagepath";

export default {
  Data: [
    {
      Id: "1",
      key:1,
      Category: "Advertising",
      img: Category1,
      Total: 60,
    },
    {
      Id: "2",
      key:2,
      Category: "Food",
      img: Category2,
      Total: 55,
    },
    {
      Id: "3",
      key:3,
      Category: "Marketing",
      img: Category3,
      Total: 70,
    },

    {
      Id: "4",
      key:4,
      Category: "Repairs",
      img: Category4,
      Total: 82,
    },
    {
      Id: "5",
      key:5,
      Category: "Software",
      img: Category5,
      Total: 26,
    },

    {
      Id: "6",
      key:6,
      Category: "Stationary",
      img: Category6,
      Total: 60,
    },
    {
      Id: "7",
      key:7,
      Category: "Advertising",
      img: Category1,
      Total: 60,
    },
    {
      Id: "8",
      key:8,
      Category: "Food",
      img: Category2,
      Total: 55,
    },
    {
      Id: "9",
      key:9,
      Category: "Marketing",
      img: Category3,
      Total: 70,
    },
  ],
};
